import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import api from '../api/api'
import { Container, Card, Row, Col, Form, FormControl, FormSelect, Button, Nav } from 'react-bootstrap'
import PageTitle from '../components/common/PageTitle'
import { useTranslation } from "react-i18next";
import swal from 'sweetalert'
import LeafletMap from '../views/map'
import './AdminManagement.css'

const SensorsList = () => {

  const { t } = useTranslation();

  const [clicked, setClicked] = useState(false)
  const params = useParams();
  const [sensors, setSensors] = useState([]);
  const [resultScan, setResultScan] = useState('');
  const [fieldUid, setFieldUid] = useState('');
  const [coords, setCoords] = useState({
    Latitude: "",
    Longitude: "",
    zoom: "",
    center: [],
    fromAction: false
  })
  const [configMap, setConfigMap] = useState({
    draw: {
      polygon: false,
      circle: false,
      rectangle: false,
      polyline: false,
      marker: true,
      circlemarker: false,
    },
    edit: {
      delete: false,
      edit: false
    }
  })
  let Uid = params.uid;

  useEffect(() => {
    getSensorsByUser()
  }, [])

  const getSensorsByUser = async () => {
    await api.get(`/admin/user/${Uid}/sensors`)
      .then(res => {
        let SensorsData = res.data.sensors;
        setSensors(SensorsData)
      }).catch(error => {
        console.error(error)
      })
  }
  const [fields, setFields] = useState([]);
  const [farms, setFarms] = useState([])

  const getFieldsByUser = async () => {
    await api.get(`/admin/user/${Uid}/fields`)
      .then(response => {
        if (response.data.type === "success") {
          let FarmsData = response.data.farms
          setFarms(FarmsData);
        }

      }).catch(error => {
        console.error(error)
      })
  }

  const getFields = () => {
    let Fields = [];
    farms.map(item => {
      let fields = item.fields;
      if (fields) {
        fields.map(field => {
          Fields.push({
            title: field.name,
            status: field.status,
            description: field.description,
            Uid: field.uid,
            farm_id: field.farm_id,
            Id: field.id
          })
        })
      }
    })
    setFields(Fields)
  }
  useEffect(() => {
    getFieldsByUser();
  }, [])

  useEffect(() => {
    getFields()
  }, [farms])


 

  const handleDelete = async sensorUid => {
    let data = {
      sensor_uid: sensorUid,
    }
    await api.delete('/sensor/delete-sensor', { data: data })
      .then(response => {
        if (response.data.type && response.data.type == "danger") {
          swal({
            title: `${t('cannot_delete')}`,
            icon: "warning",
          });
        }
        if (response.data.type == "success") {
          getSensorsByUser()

        }
      }).catch(error => {
        swal({
          title: `${t('cannot_delete')}`,
          icon: "error",
          text: t("error")

        });
      })
  }



  const addSensor = async () => {

    let data = {
      code: resultScan,
      user_uid: Uid,
      field_uid: fieldUid,
      Latitude: coords.Latitude,
      Longitude: coords.Longitude
    }
    await api.post('/supplier/add-sensor', data)
      .then(response => {
        if (response.data.type === "success") {
          swal(t('sensor_added'), { icon: "success" });
          getSensorsByUser()
          setResultScan('')
          setClicked(false)
        }
      }).catch(() => {
        swal(t("error"), { icon: "error" })
      })
  }

  const _onCreated = e => {
    let type = e.layerType;
    let layer = e.layer;
    if (type === "marker") {
      layer.bindPopup(t('sensor_code'));
    }

    setCoords({ Latitude: layer.getLatLng().lat, Longitude: layer.getLatLng().lng });

  };
  

  const displayForm = (code) => {
    if (code !== '') {
      setClicked(!clicked)
      setResultScan(code)

    }
  }

  return (
    <>
      <Container className="admin-management-page">
        <Nav justified variant="pills" className="admin-management-tabs">

          <Nav.Item>
            <Nav.Link as={Link} to={`/admin/user/${Uid}`}>
              {t('profile')}
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link as={Link} to={`/admin/user/${Uid}/farms`}>
              {t('farms')}
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link as={Link} to={`/admin/user/${Uid}/fields`}>
              {t('fields')}
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link active>
              {t('sensors')}
            </Nav.Link>
          </Nav.Item>
        </Nav>
        <Container>
          <Row noGutters className="admin-management-heading">
            <PageTitle subtitle={t('add_sensor')} md="12" className="ml-sm-auto mr-sm-auto" />
          </Row>
          <Card small className="h-100 admin-data-card">
            <Card.Header className="border-bottom">
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  width: "auto",
                  float: "left"
                }}
              >
                <h6 className="m-0">{t('sensor_setup')}</h6>{" "}
              </div>
              <div className="admin-management-actions">
                <Button
                  variant="success"
                  disabled={coords.Latitude == "" ? true : false}
                  onClick={addSensor}
                >
                  <i className="fa fa-check mx-2"></i>
                  {t('save')}
                </Button>
                <Button
                  variant="outline-primary"
                  onClick={() => { setResultScan(''); setFieldUid(''); setClicked(false) }}
                >
                  <i className="fa fa-times mx-2"></i>
                  {t('cancel')}
                </Button>
              </div>
            </Card.Header>
            <Card.Body className="pt-0">
              <div
                style={{
                  display: "flex",
                  marginTop: "20px",
                  flexWrap: "wrap",
                  gap: "10px"
                }}
              >
                <Col lg="6" sm="12" md="12">
                  <Form>
                    <Row form>
                      <Col md="12" className="form-group">
                        <p style={{ margin: "0px" }}>{t('sensor_code')}</p>
                        <FormSelect
                          value={resultScan}
                          onChange={(e) => setResultScan(e.target.value)}
                          required

                        >
                          <option value="">{t('select_sensor')}</option>

                          {
                            sensors.map((item, indx) => {
                              return (

                                <option key={item.id} value={item.code}>{item.code} </option>
                              )
                            })
                          }

                        </FormSelect>

                      </Col>
                      <Col md="12" className="form-group">
                        <p style={{ margin: "0px" }}>{t('name_field')}</p>
                        <FormSelect
                          placeholder={t('name_field')}
                          required
                          value={fieldUid}
                          onChange={(e) => setFieldUid(e.target.value)}
                        >
                          <option value="">{t('select_field')}</option>
                          {
                            fields.map((item, indx) => {
                              return <option key={item.Uid} value={item.Uid}>{item.title}</option>
                            })
                          }
                        </FormSelect>
                      </Col>
                      {/* <Col md="6" className="form-group">
                            <p style={{ margin: "0px" }}>{t('name_zone')}</p>
                            <FormSelect
                              placeholder={t('zone_name')}

                            >
                              <option value="">{t('select_zone')}</option>
                            </FormSelect>
                          </Col> */}
                    </Row>
                  </Form>
                  {/* <div>
                        <h3>{t('scan_qrcode_sensor')}</h3>
                        <Html5QrcodePlugin
                          fps={10}
                          qrbox={250}
                          disableFlip={true}
                          rememberLastUsedCamera={false}
                          qrCodeSuccessCallback={onNewScanResult}

                        />
                      </div> */}
                </Col>
                <Col lg="5" md="12" sm="12" className="mb-4">
                  <div style={{ textAlign: "center", margin: "5px" }}>
                    <i className='material-icons mx-2'>&#xe88e;</i>
                    {t('sensor_position_hint')}

                  </div>
                  <LeafletMap _onCreated={_onCreated} draw={configMap.draw} edit={configMap.edit} zoom={coords.zoom} center={coords.center} fromAction={coords.fromAction} />

                </Col>
              </div>
            </Card.Body>
          </Card>
        </Container>
        <Row noGutters className="admin-management-heading">
          <PageTitle subtitle={t('sensors')} md="12" className="ml-sm-auto mr-sm-auto" />
        </Row>
        <Card className="admin-data-card">
          <table className="table mb-0 text-center">
            <thead className="bg-light">
              <tr>
                <th scope="col" className="border-0">{t('sensor_code')}</th>
                <th scope="col" className="border-0">{t('list_fields')}</th>
                <th scope="col" className="border-0">{t('Actions')}</th>
              </tr>
            </thead>
            <tbody>
              {
                sensors.map((item, indx) => {
                  let fieldName = '-'
                  fields.map(field => {
                    if (field.Id === item.field_id) {
                      fieldName = field.title
                    }
                  })
                  return (

                    <tr key={item.id}>
                      <td>{item.code}</td>
                      <td>{fieldName}</td>
                      <td>
                        <Button
                          disabled={clicked}
                          variant="info"
                          size="sm"
                          onClick={() => displayForm(item.code)}
                        >
                          {t('assign_to_field')}
                        </Button>
                      </td>
                    </tr>
                  )
                })
              }
            </tbody>
          </table>
        </Card>

      </Container>
    </>
  )

}

export default SensorsList